import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-upload-fats',
  standalone: false,
  templateUrl: './upload-fats.component.html',
  styleUrl: './upload-fats.component.scss',
})
export class UploadFatsComponent implements OnInit, AfterViewInit {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
    @Input() schemeType: any;
  apiUrl = environment.APIUrl;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  rfpdata: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedFileName: string = '';
  file: File;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  // @Input() schemeType: string;
  userID: any;
  selectedFinalOfferFiles: File[] = [];
  filesList: any;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.commentForm = this.fb.group({
      final_offer: [''],
      fat_date: ['', Validators.required],
      fat_venue: ['', Validators.required],
      qa_agency: ['', Validators.required],
      dispatch_clearance_date: ['', Validators.required],
      dispatch_clearance_by: ['', Validators.required],
    });
    this.getRfpDetails();
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  getRfpDetails() {
    let url;
    url = `/revenue/fats/prototype/`;

    this.api
      .getAPI(
        url +
        `?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((res: any) => {
        if (res?.length > 0) {
          this.rfpdata = res[0];
          this.filesList = res[0].fat_files

          this.commentForm.patchValue({
            final_offer: this.rfpdata?.comment || '',
            fat_date: this.rfpdata?.fat_date || '',
            fat_venue: this.rfpdata?.fat_venue || '',
            qa_agency: this.rfpdata?.qa_agency || '',
            dispatch_clearance_date: this.rfpdata?.dispatch_clearance_date || '',
            dispatch_clearance_by: this.rfpdata?.dispatch_clearance_by || '',
          });

          // this.finalOfferFilePath = this.rfpdata?.fat_report || null; // <-- set existing file path
          this.selectedFinalOfferFile = null; // clear any previously selected file
          // this.commentForm.disable();
        }
      });
  }

  onUpload(event: any): void {
    const files = event.files;
    if (!files?.length) return;
    // Append new files to the array (avoid duplicates if needed)
    this.selectedFinalOfferFiles.push(...files);
  }

  onSubmit(): void {
    let vendor_id = sessionStorage.getItem('final_vendor');
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('vendor_id', vendor_id);
    formData.append('comment', this.commentForm.get('final_offer').value);
    formData.append('fat_date', this.commentForm.get('fat_date').value);
    formData.append('fat_venue', this.commentForm.get('fat_venue').value);
    formData.append('qa_agency', this.commentForm.get('qa_agency').value);
    formData.append('dispatch_clearance_date', this.commentForm.get('dispatch_clearance_date').value);
    formData.append('dispatch_clearance_by', this.commentForm.get('dispatch_clearance_by').value);

    let url = `/revenue/fats/prototype/`;

    if (this.rfpdata?.id) {
      this.api
        .putAPI(url + this.rfpdata?.id + '/', formData)
        .subscribe((res: any) => {
          this.finalOfferFilePath = res?.file || null;
          this.selectedFinalOfferFile = null;
          this.selectedFinalOfferFiles = []

          this.getRfpDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Data updated successfully',
          });
        });
    } else {
      this.api.postAPI(url, formData).subscribe((res: any) => {
        this.selectedFinalOfferFile = null;
        this.finalOfferFilePath = res?.file || null;
        this.selectedFinalOfferFiles = []
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data  uploaded successfully',
        });
        // this.stepCompleted.emit();
      });
    }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.payload.proposal_name },
        { key: 'Comment', value: this.commentForm.get('final_offer')?.value },
        { key: 'FAT Date', value: this.commentForm.get('fat_date')?.value },
        { key: 'FAT Venue', value: this.commentForm.get('fat_venue')?.value },
        { key: 'QA Agency', value: this.commentForm.get('qa_agency')?.value },
        { key: 'Dispatch Clearance Date', value: this.commentForm.get('dispatch_clearance_date')?.value },
        { key: 'Dispatch Clearance By', value: this.commentForm.get('dispatch_clearance_by')?.value },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }

}
